export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_01.70a62cd1.mp4";